import React, { useEffect, useState, useRef } from "react";
import ReactQuill from "react-quill";
import { setIsLoading } from "../../redux/layout_slice";
import {
  excelSheetChapterValuesEndPoint,
  excelSheetNamesValuesEndPoint,
  extractColumnsValuesEndPoint,
  getColumnNamesEndPoint,
  sendImageMessageEndPoint,
  sendMessageEndPoint,
  templatesListEndPoint,
  messageStatusEndPoint,
} from "../../service/api_endpoints";
import {
  getAxiosWithToken,
  postAxiosFormWithToken,
  postAxiosWithToken,
} from "../../service/axios_service";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { useFormik } from "formik";
import ChapterList from "./chapter_list";
import toast from "react-hot-toast";
import * as htmlToImage from "html-to-image";
import { exportToExcel } from "react-json-to-excel";

export default function SendMessage() {
  const dispatch = useDispatch();

  const [templateList, setTemplateList] = useState([]);
  const [columnNameList, setColumnNameList] = useState([]);
  const [selectedColumnNameList, setSelectedColumnNameList] = useState([]);

  const [selectedTempalte, setSelectedTemplate] = useState(null);
  const [selectedTemplateName, setSelectedTemplateName] = useState(null);
  const [selectedChapterList, setSelectedChapterList] = useState([]);

  const [submitLoading, setSubmitLoading] = useState(false);
  const [sendMessageLoading, setSendMessageLoading] = useState(false);
  const [leaveColumnEnabled, setLeaveColumnEnabled] = useState(false);
  const [sortColumnEnabled, setSortColumnEnabled] = useState(false);

  const [selectedSortColumn, setSelectedSortColumn] = useState("");
  const [selectedLeaveColumn, setSelectedLeaveColumn] = useState("");
  const [selectedValidatedColumn, setSelectedValidatedColumn] = useState(null);

  const [selectedSheetName, setSelectedSheetName] = useState(null);
  const [sheetNameList, setSheetNameList] = useState([]);

  const [innerText, setInnerText] = useState("");

  const [firstSubmit, setFirstSubmit] = useState(false);
  const [overviewData, setOverviewData] = useState([]);
  const [overviewDataColumn, setOverviewDataColumn] = useState([]);

  const [messageResponse, setMessageRespone] = useState([]);
  const [responsePopUp, setResponsePopUp] = useState(false);
  const [isPolling, setIsPolling] = useState(false);
  const [currentMessageId, setCurrentMessageId] = useState(null);

  const [hasMultiSheet, setHasMultiSheet] = useState(false);
  const [multiSheetDataList, setMultiSheetDataList] = useState([]);

  const [hasLink, setHasLink] = useState(false);
  const [selectedLinkColumnIndex, setSelectedLinkColumnIndex] = useState(null);

  const pollIntervalRef = useRef(null);

  const toolbarOptions = [
    ["bold", "italic", "underline", "strike"],
    ["blockquote"],
    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ size: ["small", false, "large", "huge"] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }],
    [{ align: [] }],
  ];

  useEffect(() => {
    getTemplates();
    return () => {
      if (pollIntervalRef.current) {
        clearInterval(pollIntervalRef.current);
      }
    };
  }, []);

  const getTemplates = async () => {
    dispatch(setIsLoading(true));
    try {
      let response = await getAxiosWithToken({
        url: templatesListEndPoint,
      });
      if (response != null) {
        setTemplateList(response.data.list || []);
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch templates");
    } finally {
      dispatch(setIsLoading(false));
    }
  };

  const showColumns = async (selectedIndex) => {
    const formData = new FormData(document.getElementById("messageform"));
    formData.append("selected_sheet", selectedIndex);

    if (formik.values?.excel_file && formik.values.excel_file instanceof File) {
      formData.set("excel_file", formik.values.excel_file);
    } else {
      console.warn("showColumns: no file present in formik.values.excel_file");
    }

    let response = await postAxiosFormWithToken({
      url: getColumnNamesEndPoint,
      body: formData,
    });

    const resBody = response?.data ?? response ?? null;

    if (!resBody) {
      toast.error("No response from server for columns");
      return;
    }

    if (resBody.column_list) {
      setColumnNameList(resBody.column_list || []);
    } else if (resBody.message) {
      toast.error(resBody.message);
    } else {
      setColumnNameList(resBody?.column_list || []);
    }
  };

  const showSheetNames = async () => {
    const formData = new FormData(document.getElementById("messageform"));

    if (formik.values?.excel_file && formik.values.excel_file instanceof File) {
      formData.set("excel_file", formik.values.excel_file);
    } else {
      console.warn("showSheetNames: no file present in formik.values.excel_file");
    }

    let response = await postAxiosFormWithToken({
      url: excelSheetNamesValuesEndPoint,
      body: formData,
    });

    const resBody = response?.data ?? response ?? null;

    if (!resBody) {
      toast.error("No response from server for sheet names");
      return;
    }

    if (resBody.sheet_name_list) {
      setSheetNameList(resBody.sheet_name_list || []);
    } else if (resBody.message) {
      toast.error(resBody.message);
    } else {
      setSheetNameList(resBody?.sheet_name_list || []);
    }
  };

  const pollMessageStatus = async (messageId) => {
    try {
      console.log("Polling status for message:", messageId);
      
      const statusResponse = await getAxiosWithToken({
        url: `${messageStatusEndPoint}${messageId}/`,
      });

      const statusData = statusResponse?.data;

      if (!statusData) {
        console.warn("No status data received");
        return false;
      }

      console.log("Polling status data:", statusData);

      // Update response list with current details
      if (statusData.details && statusData.details.length > 0) {
        // Normalize the data - ensure is_sent field exists
        const normalizedDetails = statusData.details.map(detail => ({
          ...detail,
          is_sent: detail.is_sent ?? detail.is_send ?? false,
          group_name: detail.group_name || 'Unknown Group',
          chapter_name: detail.chapter_name || '',
        }));
        
        setMessageRespone(normalizedDetails);
      } else {
        // If no details yet, show loading state
        setMessageRespone([{ 
          loading: true, 
          group_name: 'Processing messages...', 
          is_sent: false 
        }]);
      }

      // Check if complete
      if (statusData.is_complete) {
        if (pollIntervalRef.current) {
          clearInterval(pollIntervalRef.current);
          pollIntervalRef.current = null;
        }
        setIsPolling(false);
        
        toast.success(
          `✅ Completed! Success: ${statusData.success_count}, Failed: ${statusData.failed_count}`,
          { duration: 5000 }
        );
        return true;
      }

      return false;
    } catch (error) {
      console.error("Error polling status:", error);
      
      // Show error in UI
      setMessageRespone([{ 
        group_name: 'Error fetching status', 
        is_sent: false,
        error: error.message 
      }]);
      
      return false;
    }
  };

  const startPolling = (messageId) => {
    console.log("Starting polling for message ID:", messageId);
    setCurrentMessageId(messageId);
    setResponsePopUp(true);
    setMessageRespone([{ loading: true, group_name: 'Initializing...', is_sent: false }]);
    setIsPolling(true);

    // Poll immediately first time
    pollMessageStatus(messageId);

    // Then poll every 3 seconds
    pollIntervalRef.current = setInterval(() => {
      pollMessageStatus(messageId);
    }, 3000);

    // Safety timeout: stop polling after 10 minutes
    setTimeout(() => {
      if (pollIntervalRef.current) {
        clearInterval(pollIntervalRef.current);
        pollIntervalRef.current = null;
        setIsPolling(false);
        toast.error("⏱️ Polling timeout. Please check message logs for final status.", {
          duration: 5000
        });
      }
    }, 600000); // 10 minutes
  };

  const formik = useFormik({
    initialValues: {
      template: "",
      excel_file: "",
      leave_row_value: "",
    },
    validationSchema: Yup.object({
      template: Yup.string().required("Template name is required"),
    }),
    onSubmit: async (values) => {
      setSubmitLoading(true);

      if (selectedTempalte?.has_excel) {
        const file = values.excel_file;
        if (!file || !(file instanceof File)) {
          toast.error("Excel file is required for this template.");
          setSubmitLoading(false);
          return;
        }
        const supportedFormats = ["xlsx", "xls", "csv"];
        const ext = file.name.split(".").pop().toLowerCase();
        if (!supportedFormats.includes(ext)) {
          toast.error("Invalid file type. Allowed: xlsx, xls, csv");
          setSubmitLoading(false);
          return;
        }
      }

      if (selectedChapterList.length === 0) {
        toast.error("Select at least one fav group");
        setSubmitLoading(false);
        return;
      }

      let chapterList = selectedChapterList.map((c) => c.id);

      let formData = new FormData(document.getElementById("messageform"));

      if (formik.values?.excel_file && formik.values.excel_file instanceof File) {
        formData.set("excel_file", formik.values.excel_file);
      }

      if (selectedTempalte?.has_excel) {
        formData.append("leave_row", leaveColumnEnabled);
        formData.append("leave_row_value", values.leave_row_value);
        formData.append("leave_row_column_name", selectedLeaveColumn);

        const selectedSheetPayload = hasMultiSheet
          ? (Array.isArray(selectedSheetName) ? selectedSheetName.join(",") : (selectedSheetName ?? ""))
          : (selectedSheetName ?? "");
        formData.append("selected_sheet", selectedSheetPayload);

        formData.append("excel_index", selectedValidatedColumn ?? "");
        formData.append("sort_column", selectedSortColumn);
        formData.append("link_column_index", selectedLinkColumnIndex ?? "");
        formData.append("add_link", hasLink);
        formData.append(
          "sort",
          selectedTempalte != null && selectedTempalte?.is_sortable ? selectedTempalte?.is_sortable : false
        );
        formData.append("column_names", selectedColumnNameList.join(","));
        formData.append(
          "excel_image",
          selectedTempalte != null && selectedTempalte?.excel_image ? selectedTempalte?.excel_image : false
        );
      }
      formData.append(
        "has_excel",
        selectedTempalte != null && selectedTempalte?.has_excel ? selectedTempalte?.has_excel : false
      );
      formData.append("message", document.getElementById("preview").innerText);
      formData.append("template_id", selectedTempalte?.id ?? "");
      formData.append("template_name", selectedTemplateName ?? "");
      formData.append("fav_group", chapterList.join(","));

      try {
        if (selectedTempalte != null && selectedTempalte?.excel_image && hasMultiSheet) {
          let response = await postAxiosFormWithToken({
            url: excelSheetChapterValuesEndPoint,
            body: formData,
          });

          const resBody = response?.data ?? response ?? null;

          if (!resBody) {
            toast.error("No response from server for multi-sheet extract");
          } else if (resBody.data_list || Array.isArray(resBody)) {
            setFirstSubmit(true);
            setMultiSheetDataList(resBody.data_list || resBody || []);
          } else if (resBody.message) {
            toast.error(resBody.message);
          } else {
            setFirstSubmit(true);
            setMultiSheetDataList(resBody || []);
          }
        } else if (selectedTempalte != null && selectedTempalte?.excel_image) {
          let response = await postAxiosFormWithToken({
            url: extractColumnsValuesEndPoint,
            body: formData,
          });

          const resBody = response?.data ?? response ?? null;

          if (!resBody) {
            toast.error("No response from server for extract columns");
          } else if (resBody.data_list) {
            setOverviewData(resBody.data_list || []);
            setFirstSubmit(true);
            setOverviewDataColumn(resBody.column_list || []);
          } else if (resBody.message) {
            toast.error(resBody.message);
          } else {
            setOverviewData(resBody?.data_list || []);
            setFirstSubmit(true);
            setOverviewDataColumn(resBody?.column_list || []);
          }
        } else {
          // MAIN MESSAGE SENDING WITH POLLING
          let response = await postAxiosFormWithToken({
            url: sendMessageEndPoint,
            body: formData,
          });

          const resBody = response?.data ?? response ?? null;

          if (!resBody) {
            toast.error("No response from server while sending message");
          } else {
            const messageId = resBody.message_id;

            if (!messageId) {
              toast.error("No message ID received from server");
              setSubmitLoading(false);
              return;
            }

            toast.success("📤 Message sending started in background!");
            
            // Start polling
            startPolling(messageId);
          }
        }
      } catch (err) {
        console.error(err);
        toast.error("Error while submitting: " + (err.message || "Unknown error"));
      }

      setSubmitLoading(false);
    },
  });

  const sentImageMessage = async () => {
    setSendMessageLoading(true);

    let messageList = [];
    for (const i of overviewData) {
      const element = document.getElementById(i.unique_id);
      let messageData = {
        group_name: i.group_name,
        chapter: i.chapter_name,
        to: i.group_id,
        message: i.message,
        sheet_data: i.sheet_data || [],    //srinishaa
      };

      try {
        const dataUrl = await htmlToImage.toJpeg(element);
        messageData["image"] = dataUrl;
      } catch (error) {
        console.error("Error converting to image:", error);
        toast.error(`Failed to convert ${i.group_name} to image`);
      }

      messageList.push(messageData);
    }

    let response = await postAxiosWithToken({
      url: sendImageMessageEndPoint,
      body: {
        message_list: messageList,
      },
    });

    const resBody = response?.data ?? response ?? null;

    if (!resBody) {
      toast.error("No response from server when sending image messages");
      setSendMessageLoading(false);
      return;
    }

    const messageId = resBody.message_id;

    if (messageId) {
      toast.success("📤 Image messages sending started!");
      startPolling(messageId);
    } else {
      const normalized = Array.isArray(resBody) ? resBody : resBody?.list ? resBody.list : [resBody];
      setMessageRespone(normalized);
      setResponsePopUp(true);
    }

    setSendMessageLoading(false);
    resetForm();
  };

  const multiSheetMessage = async () => {
    setSendMessageLoading(true);

    let messageList = [];

    for (const i of multiSheetDataList) {
      const element = document.getElementById(i.unique_id);
      let messageData = {
        group_name: i.group_name,
        chapter: i.chapter_name,
        to: i.group_id,
        message: i.message,
        sheet_data: i.sheet_data || [],   //srinishaa
      };

      try {
        const dataUrl = await htmlToImage.toJpeg(element);
        messageData["image"] = dataUrl;
      } catch (error) {
        console.error("Error converting to image:", error);
        toast.error(`Failed to convert ${i.group_name} to image`);
      }

      messageList.push(messageData);
    }

    let response = await postAxiosWithToken({
      url: sendImageMessageEndPoint,
      body: {
        message_list: messageList,
      },
    });

    const resBody = response?.data ?? response ?? null;

    if (!resBody) {
      toast.error("No response from server when sending multi-sheet image messages");
      setSendMessageLoading(false);
      return;
    }

    const messageId = resBody.message_id;

    if (messageId) {
      toast.success("📤 Multi-sheet messages sending started!");
      startPolling(messageId);
    } else {
      const normalized = Array.isArray(resBody) ? resBody : resBody?.list ? resBody.list : [resBody];
      setMessageRespone(normalized);
      setResponsePopUp(true);
    }

    setSendMessageLoading(false);
    resetForm();
  };

  const resetForm = () => {
    formik.resetForm();
    setColumnNameList([]);
    setSelectedColumnNameList([]);
    setSelectedChapterList([]);
    setSelectedSortColumn("");
    setSelectedLeaveColumn("");
    setSelectedValidatedColumn(null);
    setSelectedLinkColumnIndex(null);
    setInnerText("");
    setOverviewData([]);
    setFirstSubmit(false);
    setOverviewDataColumn([]);
    setMultiSheetDataList([]);
    setHasMultiSheet(false);
    setSheetNameList([]);
    setSelectedSheetName(null);
    const fileEl = document.getElementById("excel_file");
    if (fileEl) fileEl.value = "";
  };

  const handleClosePopup = () => {
    if (pollIntervalRef.current) {
      clearInterval(pollIntervalRef.current);
      pollIntervalRef.current = null;
    }

    setMessageRespone([]);
    setResponsePopUp(false);
    setIsPolling(false);
    setCurrentMessageId(null);
  };

  return (
    <div>
      {firstSubmit && (
        <button
          className="text-primary hover:underline mb-4"
          onClick={(e) => {
            e.preventDefault();
            setFirstSubmit(!firstSubmit);
            formik.setFieldValue("excel_file", "");
            const fileEl = document.getElementById("excel_file");
            if (fileEl) fileEl.value = "";
          }}
        >
          ← Go back
        </button>
      )}

      {firstSubmit ? (
        !hasMultiSheet ? (
          <div className="bg-white">
            {overviewData.map((item) => (
              <div className="my-[30px]" key={item.unique_id}>
                <p className="font-bold text-xl">{item.chapter_name}</p>
                <p className="text-primary">{item.group_name}</p>
                <div className="w-full overflow-scroll">
                  <table id={item.unique_id} className="w-full">
                    <thead className="bg-light-gray text-white">
                      <tr>
                        <th className="p-[10px] text-left">S.No</th>
                        {overviewDataColumn.map((col, ci) => (
                          <th key={ci} className="p-[10px] text-left text-[30px]">
                            {col}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {item.sheet_data?.map((sheet, sheetIndex) => (
                        <tr
                          key={sheetIndex}
                          className={`${sheetIndex % 2 != 0 ? "bg-input-gray" : "bg-white"} border-b`}
                        >
                          <td className="p-[10px] text-left">{sheetIndex + 1}</td>
                          {Object.values(sheet).map((val, vi) => (
                            <td key={vi} className="p-[10px] text-left text-[30px]">
                              {val}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
            <button
              onClick={(e) => {
                e.preventDefault();
                sentImageMessage();
              }}
              type="button"
              disabled={sendMessageLoading}
              className="w-full my-[50px] bg-primary px-[15px] py-[10px] text-white rounded hover:bg-opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
            >
              {sendMessageLoading ? "Sending..." : "Send Message"}
            </button>
          </div>
        ) : (
          <div className="bg-white">
            {multiSheetDataList.map((item) => (
              <div className="my-[30px]" key={item.unique_id}>
                <p className="font-bold text-xl">{item.chapter_name}</p>
                <div className="w-full overflow-scroll">
                  <table id={item.unique_id} className="w-full">
                    <thead className="bg-light-gray text-white">
                      <tr>
                        <th className="p-[10px] text-left">Chapter Name</th>
                        <th className="p-[10px] text-left">Name</th>
                        <th className="p-[10px] text-left">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {item?.sheet_data?.map((subItem, sheetIndex) => (
                        <tr
                          key={sheetIndex}
                          className={`${sheetIndex % 2 != 0 ? "bg-input-gray" : "bg-white"} border-b`}
                        >
                          <td className="p-[10px] text-left text-[30px]">{item.chapter_name}</td>
                          <td className="p-[10px] text-left text-[30px]">{subItem.name}</td>
                          <td className="p-[10px] text-left text-[30px]">{subItem.message}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
            <button
              onClick={(e) => {
                e.preventDefault();
                multiSheetMessage();
              }}
              type="button"
              disabled={sendMessageLoading}
              className="w-full my-[50px] bg-primary px-[15px] py-[10px] text-white rounded hover:bg-opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
            >
              {sendMessageLoading ? "Sending..." : "Send Message"}
            </button>
          </div>
        )
      ) : (
        <div>
          <div className="flex items-start justify-between gap-3">
            <form onSubmit={formik.handleSubmit} id="messageform" encType="multipart/form-data" className="flex-1">
              <div className="mb-[25px]">
                <p className="mb-2 font-medium">Select Template</p>
                <select
                  name="template"
                  id="template"
                  value={formik.values.template}
                  onChange={(e) => {
                    const val = e.target.value;
                    const matched = templateList.find((t) => t.id.toString() === val);
                    if (matched) {
                      setSelectedTemplate(matched);
                      setSelectedTemplateName(matched.template_name);
                      setInnerText(matched.content_html || "");
                      setLeaveColumnEnabled(matched.leave_row);
                      setSortColumnEnabled(matched.is_sortable);
                      setHasMultiSheet(matched.has_multi_sheet);
                      setHasLink(matched.has_link);
                      setSelectedColumnNameList([]);
                      setColumnNameList([]);
                      setSheetNameList([]);
                      setSelectedSheetName(matched.has_multi_sheet ? [] : null);
                    } else {
                      setSelectedTemplate(null);
                      setSelectedTemplateName(null);
                      setInnerText("");
                      setLeaveColumnEnabled(false);
                      setSortColumnEnabled(false);
                      setHasMultiSheet(false);
                      setHasLink(false);
                      setSelectedSheetName(null);
                    }
                    formik.setFieldValue("template", val);
                  }}
                  className="text-sm bg-input-gray rounded focus:outline-primary w-full px-[15px] py-[10px] border border-gray-300"
                >
                  <option value={""}>-- choose template --</option>
                  {templateList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.template_name}
                    </option>
                  ))}
                </select>
                {formik.errors.template && formik.touched.template && (
                  <p className="text-red-500 text-xs mt-1">{formik.errors.template}</p>
                )}
              </div>

              <div className="mb-[25px]">
                <p className="mb-2 font-medium">Message</p>
                <ReactQuill
                  theme="snow"
                  value={innerText}
                  onChange={(value) => {
                    setInnerText(value);
                  }}
                  modules={{
                    toolbar: toolbarOptions,
                  }}
                />
              </div>

              {selectedTempalte?.has_excel && (
                <div className="mb-[25px]">
                  <p className="mb-2 font-medium">Attach Excel</p>
                  <input
                    type="file"
                    id="excel_file"
                    name="excel_file"
                    accept=".xlsx,.xls,.csv"
                    onChange={(e) => {
                      const file = e.currentTarget.files[0];
                      formik.setFieldValue("excel_file", file || "");
                      const supportedFormats = ["xlsx", "xls", "csv"];
                      if (file && supportedFormats.includes(file.name.split(".").pop().toLowerCase())) {
                        showSheetNames();
                      }
                    }}
                    className="text-sm bg-input-gray rounded focus:outline-primary w-full px-[15px] py-[10px] border border-gray-300"
                  />
                  {formik.errors.excel_file && formik.touched.excel_file && (
                    <p className="text-red-500 text-xs mt-1">{formik.errors.excel_file}</p>
                  )}
                </div>
              )}

              {sheetNameList.length > 0 && (
                <div className="mb-[25px]">
                  <p className="mb-2 font-medium">Select Sheet Name{hasMultiSheet ? " (multiple allowed)" : ""}</p>
                  <div className="flex w-fit items-center border rounded overflow-hidden">
                    {sheetNameList.map((item, index) => {
                      if (hasMultiSheet) {
                        const checked = Array.isArray(selectedSheetName) && selectedSheetName.includes(index);
                        return (
                          <label key={index} className="cursor-pointer text-left w-fit p-[8px] flex items-center hover:bg-gray-100 transition-colors">
                            <input
                              type="checkbox"
                              checked={checked}
                              onChange={() => {
                                const curr = Array.isArray(selectedSheetName) ? [...selectedSheetName] : [];
                                if (checked) {
                                  const i = curr.indexOf(index);
                                  if (i > -1) curr.splice(i, 1);
                                  setSelectedSheetName(curr);
                                  if (curr.length === 0) {
                                    setColumnNameList([]);
                                  } else {
                                    const lastIndex = curr[curr.length - 1];
                                    if (typeof lastIndex === "number") {
                                      showColumns(lastIndex);
                                    }
                                  }
                                } else {
                                  curr.push(index);
                                  setSelectedSheetName(curr);
                                  showColumns(index);
                                }
                              }}
                              className="mr-2"
                            />
                            <span className={`${checked ? "bg-light-gray text-white font-bold p-[3px] rounded" : ""}`}>{item}</span>
                          </label>
                        );
                      } else {
                        return (
                          <p
                            key={index}
                            onClick={() => {
                              showColumns(index);
                              setSelectedSheetName(index);
                            }}
                            className={`${selectedSheetName == index ? "bg-light-gray text-white font-bold" : ""} cursor-pointer text-left w-fit p-[8px] hover:bg-gray-100 transition-colors`}
                          >
                            {item}
                          </p>
                        );
                      }
                    })}
                  </div>
                </div>
              )}

              {columnNameList.length > 0 && (
                <div className="mb-[25px]">
                  <p className="mb-2 font-medium">Select Validation Column</p>
                  <div className="flex w-fit p-[5px] items-center border rounded flex-wrap">
                    {columnNameList.map((item, index) => (
                      <p
                        key={index}
                        onClick={() => {
                          setSelectedValidatedColumn(index);
                        }}
                        className={`${selectedValidatedColumn == index ? "bg-light-gray text-white font-bold" : ""} cursor-pointer text-left w-fit p-[5px] m-1 rounded hover:bg-gray-200 transition-colors`}
                      >
                        {item}
                      </p>
                    ))}
                  </div>
                </div>
              )}

              {columnNameList.length > 0 && (
                <div className="mb-[25px]">
                  <p className="mb-2 font-medium">Select Column Names</p>
                  <div className="flex w-fit items-center border rounded flex-wrap">
                    {columnNameList.map((item, idx) => (
                      <p
                        key={idx}
                        onClick={() => {
                          if (selectedColumnNameList.includes(item)) {
                            const data = [...selectedColumnNameList];
                            const index = data.findIndex((column) => column == item);
                            data.splice(index, 1);
                            setSelectedColumnNameList(data);
                          } else {
                            setSelectedColumnNameList([...selectedColumnNameList, item]);
                          }
                        }}
                        className={`${selectedColumnNameList.includes(item) ? "bg-light-gray text-white font-bold" : ""} cursor-pointer text-left w-fit p-[5px] m-1 rounded hover:bg-gray-200 transition-colors`}
                      >
                        {item}
                      </p>
                    ))}
                  </div>
                </div>
              )}

              {columnNameList.length > 0 && hasLink && (
                <div className="mb-[25px]">
                  <p className="mb-2 font-medium">Select Link Column</p>
                  <div className="flex w-fit p-[5px] items-center border rounded flex-wrap">
                    {columnNameList.map((item, index) => (
                      <p
                        key={index}
                        onClick={() => setSelectedLinkColumnIndex(index)}
                        className={`${selectedLinkColumnIndex == index ? "bg-light-gray text-white font-bold" : ""} cursor-pointer text-left w-fit p-[5px] m-1 rounded hover:bg-gray-200 transition-colors`}
                      >
                        {item}
                      </p>
                    ))}
                  </div>
                </div>
              )}

              {sortColumnEnabled && columnNameList.length > 0 && (
                <div className="mb-[25px]">
                  <p className="mb-2 font-medium">Select Sort By</p>
                  <div className="flex w-fit items-center border rounded flex-wrap">
                    {columnNameList.map((item) => (
                      <p
                        key={item}
                        onClick={() => setSelectedSortColumn(item)}
                        className={`${selectedSortColumn == item ? "bg-light-gray text-white font-bold" : ""} cursor-pointer text-left w-fit p-[5px] m-1 rounded hover:bg-gray-200 transition-colors`}
                      >
                        {item}
                      </p>
                    ))}
                  </div>
                </div>
              )}

              {leaveColumnEnabled && columnNameList.length > 0 && (
                <div className="mb-[25px]">
                  <p className="mb-2 font-medium">Leave Column</p>
                  <div className="flex w-fit items-center border rounded flex-wrap">
                    {columnNameList.map((item) => (
                      <p
                        key={item}
                        onClick={() => setSelectedLeaveColumn(item)}
                        className={`${selectedLeaveColumn == item ? "bg-light-gray text-white font-bold" : ""} cursor-pointer text-left w-fit p-[5px] m-1 rounded hover:bg-gray-200 transition-colors`}
                      >
                        {item}
                      </p>
                    ))}
                  </div>
                </div>
              )}

              {leaveColumnEnabled && columnNameList.length > 0 && (
                <div className="mb-[25px]">
                  <p className="mb-2 font-medium">Leave Column Value</p>
                  <input
                    type="text"
                    name="leave_row_value"
                    id="leave_row_value"
                    placeholder="e.g., 0,1"
                    className="text-sm bg-input-gray rounded focus:outline-primary w-full px-[15px] py-[10px] border border-gray-300"
                    onChange={formik.handleChange}
                    value={formik.values.leave_row_value}
                  />
                  {formik.errors.leave_row_value && formik.touched.leave_row_value && (
                    <p className="text-red-500 text-xs mt-1">{formik.errors.leave_row_value}</p>
                  )}
                </div>
              )}

              <button 
                type="submit" 
                id="firstsubmit" 
                className="hidden w-full my-[50px] bg-primary px-[15px] py-[10px] text-white rounded"
              >
                {submitLoading ? "Loading..." : "Submit"}
              </button>
            </form>

            {innerText && innerText.length > 0 && (
              <div className="flex-1">
                <p className="my-[10px] font-bold text-primary">Template Preview</p>
                <div 
                  id="preview" 
                  dangerouslySetInnerHTML={{ __html: innerText }} 
                  className="w-full break-all text-sm border rounded shadow p-[10px] bg-gray-50"
                ></div>
              </div>
            )}
          </div>

          <p className="mt-[25px] mb-[15px] font-bold text-xl">Fav Group List</p>
          <div className="grid 2xl:grid-cols-2 xl:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 sm:grid-cols-1 gap-3">
            <div className="w-full">
              <ChapterList 
                setSelectedChapterList={setSelectedChapterList} 
                selectedChapterList={selectedChapterList} 
              />
            </div>

            <div className="w-full mt-[60px] overflow-scroll border rounded shadow">
              <table className="w-full">
                <thead className="bg-light-gray text-white">
                  <tr>
                    <th className="p-[10px] text-left">S No</th>
                    <th className="p-[10px] text-left">Chapter Name</th>
                    <th className="p-[10px] text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedChapterList.length > 0 ? (
                    selectedChapterList.map((item, index) => (
                      <tr
                        key={item.id ?? index}
                        className={`${index % 2 != 0 ? "bg-input-gray" : ""} border-b hover:bg-gray-100 transition-colors`}
                      >
                        <td className="p-[10px]">{index + 1}</td>
                        <td className="p-[10px]">{item.chapter_name}</td>
                        <td className="p-[10px] text-center">
                          <button
                            onClick={() => {
                              const data = [...selectedChapterList];
                              data.splice(index, 1);
                              setSelectedChapterList(data);
                            }}
                            className="text-red-600 hover:text-red-800 font-semibold"
                          >
                            Remove
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={3} className="p-[20px] text-center text-gray-500">
                        No chapters selected
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("firstsubmit").click();
            }}
            disabled={submitLoading}
            className="w-full my-[50px] bg-primary px-[15px] py-[10px] text-white rounded hover:bg-opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-all font-semibold"
          >
            {submitLoading ? "Processing..." : selectedTempalte?.excel_image ? "Preview" : "Send Message"}
          </button>
        </div>
      )}

      {responsePopUp && (
        <div className="w-screen h-screen bg-black fixed z-[9999] top-0 left-0 bg-opacity-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg shadow-2xl p-[30px] w-full max-w-3xl max-h-[85vh] overflow-hidden flex flex-col">
            <div className="flex items-center justify-between mb-6">
              <h2 className="font-bold text-2xl text-gray-800">Message Sent Status</h2>
              {isPolling && (
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 bg-blue-500 rounded-full animate-pulse"></div>
                  <span className="text-sm text-blue-600 font-medium">Live Updates</span>
                </div>
              )}
            </div>

            {isPolling && (
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                <p className="text-blue-700 font-medium flex items-center gap-2">
                  <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Sending messages in progress...
                </p>
                <p className="text-sm text-blue-600 mt-2">This popup will update automatically with live status</p>
              </div>
            )}

            <div className="flex-1 overflow-y-auto mb-4 space-y-2">
              {messageResponse.length > 0 ? (
                messageResponse.map((item, idx) => (
                  <div 
                    className={`flex gap-3 justify-between items-center p-4 rounded-lg border transition-all ${
                      item.loading 
                        ? 'bg-blue-50 border-blue-200' 
                        : item.is_sent 
                        ? 'bg-green-50 border-green-200 hover:bg-green-100' 
                        : 'bg-red-50 border-red-200 hover:bg-red-100'
                    }`}
                    key={item.group_id ?? item.id ?? idx}
                  >
                    <div className="flex-1">
                      <p className="font-medium text-gray-800">
                        {item.group_name ?? "Processing..."}
                      </p>
                      {item.chapter_name && (
                        <p className="text-xs text-gray-600 mt-1">
                          📁 {item.chapter_name}
                        </p>
                      )}
                      {item.error && (
                        <p className="text-xs text-red-600 mt-1 bg-red-100 p-2 rounded">
                          ⚠️ {item.error}
                        </p>
                      )}
                    </div>
                    
                    <div className="flex items-center">
                      {item.loading ? (
                        <div className="flex items-center gap-2">
                          <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></div>
                          <span className="text-blue-600 font-medium">Sending...</span>
                        </div>
                      ) : item.is_sent ? (
                        <div className="flex items-center gap-2">
                          <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                          </svg>
                          <span className="text-green-600 font-semibold">Sent</span>
                        </div>
                      ) : (
                        <div className="flex items-center gap-2">
                          <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                          </svg>
                          <span className="text-red-600 font-semibold">Failed</span>
                        </div>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center text-gray-500 py-12">
                  <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                  </svg>
                  <p className="mt-2">No messages to display</p>
                </div>
              )}
            </div>

            <div className="flex gap-3 pt-4 border-t">
              <button
                className="flex-1 bg-gray-600 px-[15px] py-[12px] text-white rounded-lg hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all font-semibold"
                onClick={handleClosePopup}
                disabled={isPolling}
              >
                {isPolling ? "Sending in progress..." : "Close"}
              </button>

              {messageResponse.length > 0 && !isPolling && !messageResponse[0]?.loading && (
                <button 
                  className="flex-1 bg-green-600 px-[15px] py-[12px] text-white rounded-lg hover:bg-green-700 transition-all font-semibold flex items-center justify-center gap-2" 
                  onClick={() => {
                    const exportData = messageResponse.map((item, idx) => ({
                      'S.No': idx + 1,
                      'Group Name': item.group_name || 'Unknown',
                      'Chapter': item.chapter_name || '-',
                      'Status': item.is_sent ? 'Sent' : 'Failed',
                      'Error': item.error || '-'
                    }));
                    exportToExcel(exportData, `message-status-${Date.now()}`);
                  }}
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  Export to Excel
                </button>
              )}
            </div>

            {isPolling && (
              <p className="text-xs text-gray-500 text-center mt-3">
                💡 You can close this popup and check status later in Message Logs
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}